import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AUTH_STORAGE_KEYS } from '@core/services/api/auth.constants';
import { AuthSessionService } from '@core/services/auth-session.service';
import { StorageService } from '@core/services/storage.service';

// Strips ?token= from URL when the user is already authenticated, avoiding loops
export const stripTokenGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);
  const storage = inject(StorageService);

  const isAuthenticated = auth.snapshot.isAuthenticated;
  const hasToken = route.queryParamMap.has('token');

  if (!isAuthenticated || !hasToken) {
    return true;
  }

  // Build a UrlTree from the current URL and drop the token param
  const tree = router.parseUrl(state.url);
  if (tree.queryParams && 'token' in tree.queryParams) {
    try {
      const currentUrl = new URL(window.location.href);
      const rawToken = currentUrl.searchParams.get('token');
      if (rawToken) {
        storage.save(AUTH_STORAGE_KEYS.STASHED_URL_TOKEN, rawToken, 'session');
      }
    } catch {
      // no-op if URL parsing fails (shouldn't happen in browser)
    }
    delete (tree.queryParams as Record<string, unknown>)['token'];
  }
  return tree;
};
